var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09057 22.5C10.7364 22.5 12.1136 21.2905 12.4298 19.6875H5.75C6.06758 21.2905 7.44475 22.5 9.09057 22.5Z",
    fill: "#0B2540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09132 2.49773H9.11084L9.13032 2.49651C10.0061 2.44175 11.4191 2.79995 12.6202 4.0686C13.8121 5.3276 14.8409 7.5358 14.8409 11.2495V11.2591L14.8412 11.2688C14.9008 13.2054 15.7354 15.0525 17.1974 16.3178L17.1977 16.3181C17.4812 16.563 17.6139 16.9406 17.5365 17.3267C17.4459 17.7785 17.0045 18.124 16.4872 18.124H1.69279C1.19995 18.124 0.7745 17.8122 0.660966 17.386C0.555782 16.9833 0.688055 16.5805 0.96943 16.3316C2.48911 15.0047 3.35275 13.0816 3.35275 11.0497V8.43565C3.35275 5.13716 5.94075 2.49773 9.09132 2.49773Z",
    stroke: "#0B2540",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0024 4.68701C20.0024 7.27565 17.9677 9.37403 15.4577 9.37403C12.9477 9.37403 10.9131 7.27565 10.9131 4.68701C10.9131 2.09838 12.9477 0 15.4577 0C17.9677 0 20.0024 2.09838 20.0024 4.68701Z",
    fill: "#2F49D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c44f6d8e.svg";
export { ForwardRef as ReactComponent };